import { render, staticRenderFns } from "./ReturnRequests.vue?vue&type=template&id=48998433&scoped=true&"
import script from "./ReturnRequests.vue?vue&type=script&lang=js&"
export * from "./ReturnRequests.vue?vue&type=script&lang=js&"
import style0 from "./ReturnRequests.vue?vue&type=style&index=0&id=48998433&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48998433",
  null
  
)

export default component.exports